import React from 'react';

import { SpecSection } from 'Components/SpecSection';

import { useVehicleDetails } from './useVehicleDetails';
import { VEHICLE_DETAILS_FIELDS } from './VehicleDetailsSection.const';

export const VehicleDetailsSection: React.FC = () => {
	const details = useVehicleDetails();

	return <SpecSection data={details} fields={VEHICLE_DETAILS_FIELDS} />;
};
